import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompanyInterface } from '../company';

@Injectable({
  providedIn: 'root',
})
export class FirebaseService {
  rtdbRef: any;

  signout = false;
  lastInResponse!: any
  constructor(
    private firebase: AngularFireDatabase,
    private firestore: AngularFirestore,
    private auth: AngularFireAuth,
  ) {

    this.rtdbRef = this.firebase.database.app.database().ref('/');
  }


  authenticateFirebase(token: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.auth.onAuthStateChanged((user: any) => {
        if (user) {
          console.log('Already Authenticated');
          resolve(null);
        } else {
          if (!this.signout) {
            this.auth
              .setPersistence('session')
              .then(() => {
                this.auth
                  .signInWithCustomToken(token)
                  .then(() => {
                    console.log('Authenticated Successfully');
                    resolve(null);
                  })
                  .catch((error) => {
                    console.log(error, 'Authenticated error 1');
                    reject(error);
                  });
              })
              .catch((error) => {
                console.log(error, 'Authenticated error 2');
                reject(error);
              });
          }
        }
      });
    });

  }
  signOut(): void {
    this.signout = true;
    this.auth
      .signOut()
      .then(() => {
        console.log('Signout');
      })
      .catch((error) => {
        console.log('Signout Error', error);
      });
  }

  getCustomerConfig() {
    /* return this.firestore.collection<any>('admin_audit_logs').snapshotChanges()
      .pipe(
        map((changes: any) => changes.map((c: any) =>
        ({
          id: c.payload.doc.id,
          ...c.payload.doc.data()
        })
        )
        )
      ) */
    return new Promise((resolve, reject) => {
      this.firebase.list(`go_live_configs`)
        .query.once('value')
        .then(res => {
          const data = res.val();
          if (data) {
            resolve(data)
          }
          resolve({});
        })
        .catch(e => {
          reject(e);
        });
    });
  }
  getSitesConfigs(companyId: string) {
    return new Promise((resolve, reject) => {
      this.firebase.list(`go_live_configs/${companyId}`)
        .query.once('value')
        .then(res => {
          const data = res.val();
          if (data) {
            resolve(Object.values(data))
          }
          resolve([]);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
  getSiteConfig(companyId: string, siteId: string) {
    return new Promise((resolve, reject) => {
      this.firebase.list(`go_live_configs/${companyId}/${siteId}`)
        .query.once('value')
        .then(res => {
          const data = res.val();
          if (data) {
            resolve(data)
          }
          resolve([]);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
  getCompanies(): Observable<CompanyInterface[]> {
    return this.firestore.collection<CompanyInterface>('customers').snapshotChanges()
      .pipe(
        map((changes: any) => changes.map((c: any) =>
        ({
          id: c.payload.doc.id,
          ...c.payload.doc.data()
        })
        )
        )
      )
  }
  getAuditLogs(): Observable<any[]> {
    return this.firestore.collection<any>('admin_audit_logs').snapshotChanges()
      .pipe(
        map((changes: any) => changes.map((c: any) =>
        ({
          id: c.payload.doc.id,
          ...c.payload.doc.data()
        })
        )
        )
      )
  }
  getAuditLogsPaginated(lastInResponse: any) {
    return new Promise((resolve, reject) => {
      let q;
      if (lastInResponse) {
        q = this.firestore.collection('admin_audit_logs', ref => ref
          .limit(10)
          .orderBy('time', 'desc')
          .startAfter(lastInResponse)
        )
      } else {
        q = this.firestore.collection('admin_audit_logs', ref => ref
          .limit(10)
          .orderBy('time', 'desc')
        )
      }
      q.get()
        .subscribe(
          {
            next: (response: any) => {
              if (!response.docs.length) {
                console.log("No Data Available");
                resolve({
                  data: [],
                  disableNext: true,
                  lastInResponse
                })
                // return false;
              } else {
                lastInResponse = response.docs[response.docs.length - 1];

                const tableData = [];
                for (let item of response.docs) {
                  tableData.push(item.data());
                }

                const data = {
                  logs: tableData,
                  disableNext: false,
                  lastInResponse
                }
                resolve(data)
              }
            }
            , error: (e: any) => {
              console.log(e);
              reject(e)
            }
          }
        );
    });

  }
  listenSiteLiveStatus(): Promise<any> {
    let url = `/site_status_observer`;
    return new Promise((resolve, reject) => {
      this.firebase.list(url)
        .query.once('value')
        .then(data => {
          resolve(data.val());
        })
        .catch(e => {
          reject(e);
        });
    });
  }
}
